export default "/_next/static/images/service-petted-desktop-2x-c03031a6465e497bff89c180b1a4d7aa.jpg";